import {svgIconWrapper} from '../svg-icon-wrapper';

import LinesLongRegular from './lines-long-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <LinesLongRegular {...props} />;
}

SvgComponent.iconName = 'linesLongRegular';

export const LinesLongRegularIcon = svgIconWrapper(SvgComponent);
